const alertsPermissions = [
  '/account/alerts',
  '/account/alerts/transaction/debit',
  '/account/alerts/transaction/credit',
];
export const managePaymentPermissions = [
  '/account/mandates/so/read',
  '/account/mandates/dd/read',
];
const paymentPermissions = [
  '/account/payments/uk/default/out',
  '/account/payments/transfer/out',
];
const potsPermission = '/account/pots';
const paymentHistoryPermissions = [
  '/account/transactions/read',
  '/account/payments/read',
];
export const paymentCapability = '/account/payments/uk/default/out';
export const stmtPreferenceCapability =
  '/account/preferences/paperstatementoptout';
const projectionsCapability = '/account/projections';
const mangageCardCapability = '/users/card/manage';
const manageDebitCardCapability = '/users/debit_card/manage';
export const viewBalanceCapability = '/account/balance/available';

const isSpendingsEnabledForAccount = ({ accountType, isSpendingsEnabled }) =>
  isSpendingsEnabled
    ? accountType === 'current' || accountType === 'credit_card'
    : false;

const accountHasPermission = (account) => (permission) =>
  account.actionsAvailable[permission] || false;

const accountHasOneOfPermissions = (account) => (permissions) =>
  permissions.some((p) => account.actionsAvailable[p]);

export const setPermissionsFromAccount = ({
  currentPermissions,
  account,
  isSpendingsEnabled,
}) => {
  const hasPermission = accountHasPermission(account);
  const hasOneOf = accountHasOneOfPermissions(account);

  return {
    ...currentPermissions,
    alertsEnabled:
      currentPermissions.alertsEnabled || hasOneOf(alertsPermissions),
    sweepsEnabled:
      currentPermissions.sweepsEnabled || hasPermission('/account/sweeps'),
    sweepsOutEnabled:
      currentPermissions.sweepsOutEnabled ||
      hasPermission('/account/sweeps/transfer/out'),
    stmtPreferenceEnabled:
      currentPermissions.stmtPreferenceEnabled ||
      hasPermission('/account/preferences/paperstatementoptout'),
    potsEnabled:
      currentPermissions.potsEnabled || hasPermission(potsPermission),
    managePaymentsEnabled:
      currentPermissions.managePaymentsEnabled ||
      hasOneOf(managePaymentPermissions),
    managePayeesEnabled:
      currentPermissions.managePayeesEnabled ||
      hasPermission('/account/beneficiaries/account/readwrite'),
    spendingsEnabled:
      currentPermissions.spendingsEnabled ||
      isSpendingsEnabledForAccount({
        accountType: account.type,
        isSpendingsEnabled,
      }),
    isCreditCardUser:
      account.type !== 'credit_card'
        ? false
        : currentPermissions.isCreditCardUser,
    paymentsEnabled:
      currentPermissions.paymentsEnabled || hasOneOf(paymentPermissions),
    manageCardEnabled:
      currentPermissions.manageCardEnabled ||
      hasPermission(mangageCardCapability),
  };
};

export const setPermissionsFromAccountList = ({
  accountList,
  currentPermissions,
  isSpendingsEnabled,
}) =>
  accountList.reduce((agg, curr) => {
    return setPermissionsFromAccount({
      currentPermissions: agg,
      account: curr,
      isSpendingsEnabled,
    });
  }, currentPermissions);

export const getAccountsWithCapability = ({ accountList, capability }) =>
  accountList.filter((account) => accountHasPermission(account)(capability));

export const getPaymentCapableAccounts = (accountList) =>
  accountList.filter((account) =>
    accountHasPermission(account)(paymentCapability)
  );

export const getAllSMEPaymentCapableAccounts = (accountList) =>
  accountList.filter((account) =>
    accountHasPermission(account)(paymentCapability)
  );

export const getDefaultAccountForBeneficiaryCreation = (accountList) =>
  accountList.find((account) =>
    accountHasPermission(account)(paymentCapability)
  );

export const getAllAccountsForPaymentsHistory = (accountList) =>
  accountList.filter((account) =>
    accountHasOneOfPermissions(account)(paymentHistoryPermissions)
  );

export const getIdOfSingleAlertsAccount = (accountList) => {
  const filteredAccounts = accountList.filter((account) =>
    accountHasOneOfPermissions(account)(alertsPermissions)
  );

  if (filteredAccounts.length === 1) {
    return filteredAccounts[0].id;
  }
  return undefined;
};

export const hasPotsPermission = (account) =>
  accountHasPermission(account)(potsPermission);

export const projectionsRequired = (account) =>
  account.type === 'current' &&
  accountHasPermission(account)(projectionsCapability);

export const getAccountsWithCapabilityAsFalse = (accountList, capability) =>
  accountList.filter(
    (account) => account.actionsAvailable[capability] === false
  );

export const isManageDebitCardEnabled = (accountList) => {
  const filteredAccounts = accountList.filter((account) =>
    accountHasPermission(account)(manageDebitCardCapability)
  );
  return filteredAccounts.length >= 1 ? true : false;
};
